import React, { useState } from 'react';
import LoginPage from './components/LoginPage';
import ChargingStation from './components/ChargingStation';           
import CleaningStation from './components/CleaningStation';
import GradingStation from './components/GradingStation';
import PackagingStation from './components/PackagingStation';
import QualityControlStation from './components/QualityControlStation';
import RepairStation from './components/RepairStation';
import RepairBatteryButtonStation from './components/RepairBatteryButtonStation';
import AssemblageDS5Station from './components/AssemblageDS5Station';
import SerialScanner from './components/SerialScanner'; 
import DepannageDS5Station from './components/DepannageDS5Station'              
import './App.css';
import packageJson from '../package.json'; 

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [debugMode, setDebugMode] = useState(false);

  const handleLogin = (userData) => {
    setUserInfo(userData);
    setIsLoggedIn(true);
    setDebugMode(false);
    localStorage.setItem('userInfo', JSON.stringify(userData));
    console.log('Utilisateur connecté et sauvegardé:', userData);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserInfo(null);
    setDebugMode(false);
    localStorage.removeItem('userInfo');
    console.log('Utilisateur déconnecté');
  };

  const stationMap = {
    "Charging": <ChargingStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Cleaning and Polishing": <CleaningStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Grading and Quality Control": <GradingStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Packaging": <PackagingStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Quality Control": <QualityControlStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Dismount": <RepairStation userInfo={userInfo} userPosition={userInfo?.position} />,
    "Assemblage DS5": <AssemblageDS5Station userInfo={userInfo} userPosition={userInfo?.position} />,
    "Scanner": <SerialScanner userInfo={userInfo} />,
    "Repair": <DepannageDS5Station userInfo={userInfo} userPosition={userInfo?.position} />
  };
  const APP_VERSION = packageJson.version;

  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} />;
  }

  if (debugMode) {
    return (
      <div className="app-container">
        <div className="debug-header">
          <h2>Scanner de Série (Debug)</h2>
          <button onClick={() => setDebugMode(false)} className="btn-back">
            ← Retour
          </button>
        </div>
        <SerialScanner userInfo={userInfo} />
      </div>
    );
  }

  const CurrentStation = stationMap[userInfo.position];

  return (
    <div className="app-container">
      <div className="user-header">
        <div className="user-info">
          <span className="user-name">Welcome  <strong>{userInfo.name}</strong></span>
          <span className="user-position">Version:{APP_VERSION}</span>
        </div>
        {/* <div className="version-center">
          <span className="app-version">Poste: <strong>{userInfo.position}</strong></span>
        </div> */}
        <div className="header-actions">
          <button onClick={handleLogout} className="btn-logout">
            Changer de poste
          </button>
        </div>
      </div>

      <div className="station-wrapper">
        {CurrentStation || (
          <div className="no-station">
            <div className="no-station-card">
              <h3>Poste non disponible</h3>
              <p><strong>{userInfo.position}</strong></p>
              <p>Interface en cours de développement.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default App;